// Static, language-agnostic data for The Real Turkish Barber (single Bray location)

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const mapEmbedUrl = (query) =>
  `https://www.google.com/maps/embed/v1/place?key=${MAPS_KEY}&q=${query}&zoom=16`;

export const heroImage =
  'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/k5fd9tcx_5.JPG';

// Single Bray branch
export const branch = {
  name: 'The Real Turkish Barber — Bray',
  address: 'Belton House, 2 Castle St, Bray Commons, Bray, Co. Wicklow, A98 E8P8',
  phone: '089 944 0644',
  mapEmbed: mapEmbedUrl('Belton+House+2+Castle+St+Bray+Commons+Bray+Co+Wicklow+A98+E8P8')
};

// Service cards — text (name/desc) comes from translations by key
export const serviceCards = [
  { key: 'haircut', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/ki6oj6na_2.JPG' },
  { key: 'skinFade', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/rl8dsoh9_2.JPG' },
  { key: 'beard', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/5whzsxcb_1.JPG' },
  { key: 'hotTowel', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/td0u4v0f_6.JPG' },
  { key: 'kids', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/0dvmadpb_3.JPG' },
  { key: 'vip', image: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/6fi85q4y_8.JPG' }
];

// Original print price list (extracted unaltered from the owner's PDF)
export const priceListImage = {
  webp: '/price-list-1200.webp',
  jpg: '/price-list-1200.jpg',
  full: '/price-list-2400.webp',
  width: 1200,
  height: 1462
};

// Text version of the printed price list (English, as printed) for screen readers & SEO
export const priceList = [
  { category: 'Haircuts', items: [
    ['Gents Haircut & Styling (includes ears & eyebrow trim, blow dry, gel/wax)', '€22'],
    ['Adult Skin Fades & Long Hair (Taper - Burst cut - Mullet - Buzz cut - Long Hair)', '€27'],
    ['Kids Haircut (Under 16)', '€20'],
    ['Kids Skin Fades & Long Hair (Under 16)', '€25'],
    ['Senior Haircut (OAP)', '€17'],
    ['Clipper All Over (Same Number)', '€17']
  ] },
  { category: 'Hair & Beard + Wax Combos', items: [
    ['Haircut & Beard Trim', '€30'],
    ['Skinfade & Beard Trim', '€35'],
    ['Haircut & Beard Trim & Hot Wax', '€37'],
    ['Skinfade & Beard Trim & Hot Wax', '€42'],
    ['Beard Trim', '€15']
  ] },
  { category: 'Shaving', items: [
    ['Hot Towel Shave', '€35'],
    ['Haircut & Hot Towel Shave', '€50'],
    ['VIP & Hot Towel Shave (includes massage + steam + hot wax)', '€55']
  ] },
  { category: 'Extras', items: [
    ['Wash & Blow Dry', '€7'],
    ['Hot Wax (Nose & Ears)', '€10'],
    ['Hot Wax (Only Nose)', '€3'],
    ['Razor For Sharp to Edges', '€3']
  ] }
];

// Real Google reviews (authentic, kept in original language)
export const clientReviews = [
  { id: 1, name: 'Christian Adizon', rating: 5, review: "I had a really good experience here! The guys are super friendly and know what they're doing. Regular customer here!" },
  { id: 2, name: 'PB', rating: 5, review: 'Service like no other! Highly recommended! Great location with easy parking.' },
  { id: 3, name: 'Lukas Slizauskas', rating: 5, review: 'Top notch haircut. If you\'re looking to get a reliable barber, this is the place to go.' },
  { id: 4, name: 'T', rating: 5, review: 'Best barber in Wicklow. As a Turk I can confirm it is the real deal unlike some others. Cavit and all staff is amazing and very helpful.' },
  { id: 5, name: 'Luke S', rating: 5, review: 'Great haircut and shave, will be back again guaranteed!' },
  { id: 6, name: 'Satisfied Customer', rating: 5, review: 'Authentic Turkish barbering experience. Professional service and excellent attention to detail.' }
];

// Gallery — authentic in-shop photos
export const galleryImages = [
  { id: 1, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/cxzsaqxy_sakal.JPG', alt: 'Traditional Turkish hot towel shave in Bray' },
  { id: 2, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/rl8dsoh9_2.JPG', alt: 'Skin fade and styling at a Bray Turkish barber' },
  { id: 3, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/o9xnkdqu_3.JPG', alt: "Men's haircut and hair design in Bray" },
  { id: 4, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/56416enq_4.JPG', alt: 'Beard grooming and facial service in Bray' },
  { id: 5, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/k5fd9tcx_5.JPG', alt: 'Turkish barber working in Bray' },
  { id: 6, src: 'https://customer-assets.emergentagent.com/job_turkishbarberie/artifacts/cxvg2zlk_6.JPG', alt: 'Hot towel shave preparation in Bray' }
];
